import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/auth.guard';
import { HomePageComponent } from './pages/home/home-page.component';
import { PropertyPageComponent } from './pages/property-page/property-page.component';
import { PropertyYearPageComponent } from './pages/property-year-page/property-year-page.component';

const routes: Routes = [
  { path: '', component: HomePageComponent },
  { path: 'properties/:property-code', component: PropertyPageComponent, canActivate: [AuthGuard] },
  { path: 'properties/:property-code/years/:year', component: PropertyYearPageComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
